import { render, staticRenderFns } from "./customer-details.vue?vue&type=template&id=ecabf304&scoped=true&"
import script from "./customer-details.vue?vue&type=script&lang=js&"
export * from "./customer-details.vue?vue&type=script&lang=js&"
import style0 from "./customer-details.vue?vue&type=style&index=0&id=ecabf304&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecabf304",
  null
  
)

export default component.exports